const registerForm = document.querySelector('#create_customer');
const inputPassword = registerForm['customer[password]'];
const inputConfirmPassword = registerForm['confirm-password'];
// const btnSubmitRegisterForm = document.querySelector('#btn-submit-register-form');

registerForm.addEventListener('submit', evt =>{
  evt.preventDefault();

  if(inputConfirmPassword.value !== inputPassword.value){
    inputConfirmPassword.setCustomValidity("Passwords do NOT match");
    inputConfirmPassword.reportValidity();
  }else{
    inputConfirmPassword.setCustomValidity("");
  }
  
  const formData = new FormData(registerForm);
  //store formData to localStorage;
  const info = {}
  Array.from(formData.entries()).forEach(it =>{
    if(/^info\[/.test(it[0])){
      info[it[0]] = it[1];
    }
    if(/^customer\[/.test(it[0])){
      info[it[0]] = it[1];
    }
  })
  localStorage.setItem('regInfo', JSON.stringify(info));
  
  if(registerForm.reportValidity()){
    if (typeof window.createObject === 'function') {
      window.createObject();
    } else {
      registerForm.submit();
    }
  }
});